export const ERROR_VERIFICATION_CODE_INCORRECT = 4; // Проверочный код на подтверждение регистрации в системе не верен
export const ERROR_VERIFICATION_CODE_EXPIRED = 5; // Проверочный код на подтверждение регистрации в системе просрочен
export const ERROR_INVALID_TOKEN = 'invalid_token';
export const ERROR_ACCESS_DENIED = 'Access Denied';

export const USER_ALREADY_REGISTERED = 'USER_ALREADY_REGISTERED';

export const RESET_ERROR = 'auth/RESET_ERROR';

export const LOGIN = 'auth/LOGIN';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_FAIL = 'auth/LOGIN_FAIL';

export const LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'auth/LOGOUT_FAIL';

export const FETCH_PROFILE = 'auth/FETCH_PROFILE';
export const FETCH_PROFILE_SUCCESS = 'auth/FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAIL = 'auth/FETCH_PROFILE_FAIL';

export const START_REGISTRATION = 'auth/START_REGISTRATION';
export const COMPLETE_REGISTRATION_SUCCESS = 'auth/COMPLETE_REGISTRATION_SUCCESS';
export const COMPLETE_REGISTRATION_FAIL = 'auth/COMPLETE_REGISTRATION_FAIL';

export const FETCH_REGISTRATION_INFO_SUCCESS = 'auth/FETCH_REGISTRATION_INFO_SUCCESS';
export const FETCH_REGISTRATION_INFO_FAIL = 'auth/FETCH_REGISTRATION_INFO_FAIL';

export const RESTORE_PASSWORD_START_SUCCESS = 'auth/RESTORE_PASSWORD_START_SUCCESS';
export const RESTORE_PASSWORD_START_FAIL = 'auth/RESTORE_PASSWORD_START_FAIL';

export const RESTORE_PASSWORD_END_SUCCESS = 'auth/RESTORE_PASSWORD_END_SUCCESS';
export const RESTORE_PASSWORD_END_FAIL = 'auth/RESTORE_PASSWORD_END_FAIL';
